import { motion } from 'framer-motion';

const infoCards = [
  {
    icon: 'ri-map-pin-line',
    title: 'Adres',
    lines: ['Konutkent Mahallesi 3028 Cadde', 'Elmar Towers C Blok No:17', 'Çankaya / Ankara'],
    accent: true,
  },
  {
    icon: 'ri-phone-line',
    title: 'Telefon',
    lines: ['0312 666 06 36'],
    accent: false,
  },
  {
    icon: 'ri-mail-line',
    title: 'E-posta',
    lines: ['info@yanginalgila.com'],
    accent: false,
  },
];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

export default function ContactInfo() {
  return (
    <motion.div
      variants={container}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      className="grid md:grid-cols-3 gap-6"
    >
      {infoCards.map((card) => (
        <motion.div
          key={card.title}
          variants={item}
          className="bg-white rounded-2xl p-7 shadow-sm hover:shadow-md transition-shadow group"
        >
          <div
            className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 ${
              card.accent ? 'bg-red-600 text-white' : 'bg-red-50 text-red-600'
            }`}
          >
            <i className={`${card.icon} text-xl`}></i>
          </div>
          <h3 className="text-base font-bold text-gray-900 mb-3">{card.title}</h3>
          <div className="space-y-1.5">
            {card.lines.map((line, i) => (
              <p key={i} className="text-sm text-gray-600 leading-relaxed">
                {line}
              </p>
            ))}
          </div>
        </motion.div>
      ))}
    </motion.div>
  );
}
